import React, { useCallback, useState } from 'react'
import styled from 'styled-components'
import { Input } from '@pancakeswap-libs/uikit'
import useI18n from 'hooks/useI18n'

interface PaginationProps {
  name: string,
  current: number,
  count: number,
  onClick?: (target: number) => void
}

const Pagination: React.FC<PaginationProps> = ({ name, current, count, onClick }) => {
    const TranslateString = useI18n();
    const renderButton = (page: number) => {
        return page === current ? (
            <StyledActiveButton disabled key={`pagination_${name}_${page}`}>{page}</StyledActiveButton>
        ) : (
            <StyledButton key={`pagination_${name}_${page}`} onClick={()=>{onClick(page);}}>{page}</StyledButton>
        );
    };

    const renderButtons = () => {
        const buttons = [];
        if (count <= 7) {
            for (let i = 1; i <= count; i++) {
                buttons.push(renderButton(i));
            }
        } else if (current <= 3 || current >= count - 2) {
            for (let i = 1; i <= 3; i++) buttons.push(renderButton(i));
            buttons.push(<span key={`pagination_${name}_ellipsis`}>...</span>);
            for (let i = count - 2; i <= count; i++) buttons.push(renderButton(i));
        } else {
            buttons.push(renderButton(1));
            buttons.push(<span key={`pagination_${name}_ellipsis1`}>...</span>);
            for (let i = current - 1; i <= current + 1; i++) buttons.push(renderButton(i));
            buttons.push(<span key={`pagination_${name}_ellipsis2`}>...</span>);
            buttons.push(renderButton(count));
        }
        return buttons;
    };

    const [val, setVal] = useState(String(current));
    const handleInputChange = (e: React.FormEvent<HTMLInputElement>) => { setVal(e.currentTarget.value); }
    const handleGoClick = useCallback(() => {
        const page = Number(val);
        if (Number.isInteger(page) && page !== current && page > 0 && page <= count) {
            onClick(page);
        }
      }, [val, count, current, onClick])
    const renderInputRow = () => {
        if (count <= 7) return "";
        return (
            <StyledInputRow>
                <StyledInputWrapper>
                    <StyledInput onChange={handleInputChange} placeholder="" value={val} onKeyDown={e => {if (e.key === 'Enter') handleGoClick()}} />
                </StyledInputWrapper>
                <StyledGo onClick={handleGoClick}>{TranslateString(1069,"Go")}</StyledGo>
            </StyledInputRow>
        )
    }

    return (
        <StyledContainer>
            <div>
                <StyledButton disabled={current===1} onClick={current===1?null:()=>{onClick(current-1);}}>{TranslateString(1067,"Prev")}</StyledButton>
                {renderButtons()}            
                <StyledButton disabled={current===count} onClick={current===count?null:()=>{onClick(current+1);}}>{TranslateString(1068,"Next")}</StyledButton>
            </div>
            {renderInputRow()}
        </StyledContainer>
    );
}

const StyledContainer = styled.div`
    text-align: center;
    margin: 30px 0 80px 0;
    color: ${({ theme }) => theme.colors.text};
`

const StyledInputRow = styled.div`
    margin-top: 30px;
`

const StyledInputWrapper = styled.span`
  display: inline-block;
  width: 80px;
  margin-right: 10px;
  vertical-align: middle;
`

const StyledInput = styled(Input)`
    height: 30px;
`

const StyledButton = styled.button<{ disabled?: boolean }>`
    color: ${({ theme }) => theme.colors.text};
    background-color: transparent;
    margin-top: 3px;
    margin-bottom: 3px;

    cursor: ${({ disabled }) => (disabled?"auto":"pointer")};
    vertical-align: middle;
    align-items: center;
    border: 0px;
    border-bottom: 0;
    border-radius: 5px;
    box-shadow: none;
    display: inline-block;
    font-family: inherit;
    font-size: 16px;
    font-weight: normal;
    height: 24px;
    line-height: 1.5em;
    letter-spacing: 0.03em;
    justify-content: center;
    outline: 0px;
    min-width: 1.5em;
    padding: 0 0.5em;
    opacity: 1;
    margin-left: 2px;
    margin-right: 2px;

    &:hover {
        background-color: ${({ disabled }) => (disabled?"inherit":"rgba(249, 140, 8, 0.7)")};
        color: ${({ disabled }) => (disabled?"inherit":"white")};
    }
`

const StyledActiveButton = styled(StyledButton)`
    background-color: rgb(249, 140, 8);
    color: white;
    cursor: auto;

    &:hover {
        background-color: rgb(249, 140, 8);
        color: white;
    }
`

const StyledGo = styled(StyledButton)`
    background-color: rgb(249, 140, 8);
    color: white;
`

export default Pagination
